export function getOpenTicketsCountLabel(count = 0) {
  if (!count || count <= 0) {
    return 'No ticket yet';
  }

  if (count === 1) {
    return '1 ticket';
  }

  return `${count} tickets`;
}

export const JIRA_SETUP_MODAL_LABELS = {
  SETUP_TITLE: 'Atlassian Jira Setup',
  RECONNECT_TITLE: 'Atlassian Jira Reconnect',
  SETUP_SUCCESS: 'Jira integration connected successfully.',
  RECONNECT_SUCCESS: 'Jira integration reconnected successfully.',
  HEADING: 'Connect NetRise to Jira',
  CANCEL: 'Cancel',
  RETRY_LINK: 'click here to retry',
  RETRY_PREFIX: 'Opens in a new tab. If not, ',
  MULTI_SITE_INFO: 'You have access to multiple sites. Pick the one to connect',
  CONFIGURATION_INFO_PREFIX: 'You can change synced Spaces anytime in ',
  CONFIGURATION_LINK: 'Configuration',
  CONFIGURATION_INFO_SUFFIX: '.',
  SELECT_ALL: 'Select All',
  SEARCH_PLACEHOLDER: 'Search',
  SELECT_SPACES_PLACEHOLDER: 'Select spaces',
  RECONNECT_HEADING_PREFIX: 'Reconnect to ',
  RECONNECT_SUBTITLE: 'Your project selections and field mappings will be kept.',
  PRESERVED_SPACES_PREFIX: 'Connected Spaces preserved',
  PRESERVED_MAPPINGS: 'Field and status mapping preserved'
};

export const JIRA_SETUP_STEP = {
  AUTHORIZE: 'AUTHORIZE',
  INSTALL_APP: 'INSTALL_APP',
  SELECT_SPACES: 'SELECT_SPACES'
};

export const JIRA_SETUP_STEP_STATUS = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  WAITING: 'WAITING',
  COMPLETED: 'COMPLETED'
};

export const JIRA_SETUP_ACTION_TYPE = {
  OPEN_ATLASSIAN: 'OPEN_ATLASSIAN',
  CONTINUE: 'CONTINUE',
  OPEN_MARKETPLACE: 'OPEN_MARKETPLACE',
  FINISH_SETUP: 'FINISH_SETUP',
  WAITING: 'WAITING',
  RECONNECT: 'RECONNECT'
};

export const JIRA_SETUP_ACTION = {
  START_AUTHORIZATION: 'START_AUTHORIZATION',
  RETRY_AUTHORIZATION: 'RETRY_AUTHORIZATION',
  SELECT_SITE: 'SELECT_SITE',
  OPEN_MARKETPLACE: 'OPEN_MARKETPLACE',
  UPDATE_SPACE_SELECTION: 'UPDATE_SPACE_SELECTION',
  FINISH_SETUP: 'FINISH_SETUP',
  CANCEL: 'CANCEL',
  START_RECONNECT: 'START_RECONNECT'
};

export const JIRA_SETUP_PRIMARY_ACTIONS = new Set([
  JIRA_SETUP_ACTION.START_AUTHORIZATION,
  JIRA_SETUP_ACTION.SELECT_SITE,
  JIRA_SETUP_ACTION.OPEN_MARKETPLACE,
  JIRA_SETUP_ACTION.FINISH_SETUP
]);

export const JIRA_SETUP_MODE = {
  SETUP: 'SETUP',
  RECONNECT: 'RECONNECT'
};

export const JIRA_SETUP_POLL_INTERVAL_MS = 5000;
